import {isValidEmailAddress} from "../../utils/email-validation";

document.addEventListener('DOMContentLoaded', function () {
    newsletter();
    newsletterUnsubscribe();
});

function newsletter() {
    const subscribeButton = document.querySelector('button.newsletter-subscribe');
    const errorContainer = document.getElementById('newsletter-subscribe-error');
    const firstName = document.getElementById('first-name');
    const lastName = document.getElementById('last-name');
    const email = document.getElementById('email');
    const dataPrivacy = document.getElementById('newsletter-subscribe-data-privacy');
    const subscribeForm = document.getElementById('newsletter-subscribe-form');
    const successForm = document.getElementById('newsletter-subscribe-form-success');

    if (!subscribeButton) {
        return;
    }

    subscribeButton.addEventListener('click', function (e) {
        e.preventDefault();
        errorContainer.innerHTML = '';
        errorContainer.style.display = 'none';
        let hasError = false;

        if (firstName.value.length < 1) {
            errorContainer.innerHTML += '<p>Geben Sie bitte Ihren Vornamen ein.</p>';
            document.querySelector('.newsletter-first-name').style.border = '1px solid #FF294A';
            hasError = true;
        } else {
            document.querySelector('.newsletter-first-name').style.border = '1px solid #ECEFF4';
        }

        if (lastName.value.length < 1) {
            errorContainer.innerHTML += '<p>Geben Sie bitte Ihren Nachnamen ein.</p>';
            document.querySelector('.newsletter-last-name').style.border = '1px solid #FF294A';
            hasError = true;
        } else {
            document.querySelector('.newsletter-last-name').style.border = '1px solid #ECEFF4';
        }

        if (!isValidEmailAddress(email.value)) {
            errorContainer.innerHTML += '<p>Geben Sie bitte Ihre E-Mail-Adresse ein.</p>';
            document.querySelector('.newsletter-email').style.border = '1px solid #FF294A';
            hasError = true;
        } else {
            document.querySelector('.newsletter-email').style.border = '1px solid #ECEFF4';
        }

        if (!dataPrivacy.checked) {
            errorContainer.innerHTML += '<p>Bitte akzeptieren Sie die Datenschutzerklärung.</p>';
            hasError = true;
        }

        if (hasError) {
            errorContainer.style.display = 'block';
            errorContainer.style.opacity = 0;

            setTimeout(() => {
                errorContainer.style.transition = 'opacity 300ms ease-in-out';
                errorContainer.style.opacity = 1;
            }, 10); // Timeout for transition effect
        } else {
            const formData = new URLSearchParams();
            formData.append('action', 'bi_AddNewsLetterContact');
            formData.append('firstname', firstName.value);
            formData.append('lastname', lastName.value);
            formData.append('email', email.value);

            fetch(ajax.url, {
                method: 'POST', body: formData, headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(response => response.text())
                .then(data => {
                    if (data === '1') {
                        subscribeForm.style.display = 'none';
                        successForm.style.display = 'block';
                        successForm.style.opacity = 0;
                        successForm.style.opacity = 0;

                        setTimeout(() => {
                            successForm.style.transition = 'opacity 300ms ease-in-out';
                            successForm.style.opacity = 1;
                        }, 10); // Timeout for transition effect

                        firstName.value = '';
                        lastName.value = '';
                        email.value = '';
                        dataPrivacy.checked = false;
                    }
                })
                .catch(error => console.error("Error:", error));
        }
    });
}

function newsletterUnsubscribe() {
    const emailInput = document.getElementById('unsubscribe-email-input');
    const errorContainer = document.getElementById('newsletter-unsubscribe-error');
    const successContainer = document.getElementById('newsletter-unsubscribe-success');
    const unsubscribeEmailField = document.getElementById('unsubscribe-email-field');
    const unsubscribeButton = document.getElementById('newsletter-unsubscribe-button');

    if (!emailInput) {
        return;
    }

    if (!unsubscribeButton) {
        return;
    }

    unsubscribeButton.addEventListener('click', function (e) {
        e.preventDefault();
        errorContainer.innerHTML = '';
        errorContainer.style.display = 'none';

        if (!isValidEmailAddress(emailInput.value)) {
            errorContainer.innerHTML = '<p>Geben Sie bitte Ihre E-Mail-Adresse ein.</p>';
            unsubscribeEmailField.style.border = '1px solid #FF294A';
            errorContainer.style.display = 'block';
            errorContainer.style.opacity = 0;

            setTimeout(() => {
                errorContainer.style.transition = 'opacity 300ms ease-in-out';
                errorContainer.style.opacity = 1;
            }, 10); // Timeout for transition effect
        } else {
            unsubscribeEmailField.style.border = '1px solid #ECEFF4';

            fetch('/wp-content/themes/binside/newsletter-proxy.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: emailInput.value,
                }),
            })
            .then(response => {
                if (response.ok) {
                    // Successful response (status code in the range 200-299)
                    return response.json();
                } else {
                    // Handle HTTP error status codes
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            })
            .then(data => {
                // Handle the successful response data
                errorContainer.style.display = 'none';
                successContainer.innerHTML = '<p>Die Abmeldung war erfolgreich.</p>';
                unsubscribeEmailField.style.border = '1px solid #16a34a';
                successContainer.style.display = 'block';
                successContainer.style.opacity = 0;

                setTimeout(() => {
                    successContainer.style.transition = 'opacity 300ms ease-in-out';
                    successContainer.style.opacity = 1;
                }, 10); // Timeout for transition effect
            })
            .catch(error => {
                // Handle network errors or HTTP error status codes
                errorContainer.innerHTML = `<p>Die Abmeldung konnte nicht durchgeführt werden: ${error.message}</p>`;
                unsubscribeEmailField.style.border = '1px solid #FF294A';
                errorContainer.style.display = 'block';
                errorContainer.style.opacity = 0;

                setTimeout(() => {
                    errorContainer.style.transition = 'opacity 300ms ease-in-out';
                    errorContainer.style.opacity = 1;
                }, 10); // Timeout for transition effect
            });
        }
    });
}
